<header [ngClass]="{ 'sticky top-0 z-10': preferencesService.floatingHeader() }">
  <div class="flex items-center justify-between w-full shadow-sm bg-white dark:bg-dark-card border-b border-gray-medium dark:border-dark-border h-[97px]">
    <div class="h-full flex items-center">
      @if (enableBack && navigationService.hasBack()) {
        <a
          href="#"
          (click)="$event.preventDefault(); navigationService.back();"
          class="h-full ease-in-out transition-all hover:bg-gray-100 dark:hover:bg-dark-hover w-[97px] flex justify-center items-center border-r border-r-gray-200 dark:border-r-dark-border"
          [title]="'common.back' | translate"
        >
          <lucide-angular [name]="ChevronLeft"></lucide-angular>
        </a>
      }
      <div class="ml-8 mt-1 flex items-center justify-center text-theme-primary">
        @if (activeMenuItem(); as active) {
          <lucide-angular size="22" [name]="active.icon"></lucide-angular>
        } @else {
          <div class="w-4 h-4 rounded border-2 border-theme-primary"></div>
        }
      </div>
      <div class="flex flex-col justify-center ml-4">
        <div
          class="w-full text-sm text-slate-400 dark:text-dark-muted font-normal uppercase flex gap-1 items-center"
          *appIsEmpty
        >
          <ng-content select="[subtitle]"></ng-content>

          @if (headerService.ressource()) {
            <div>-</div>
            <button class="bg-gray-100 dark:bg-dark-hover p-1 flex items-center gap-1 rounded cursor-pointer active:bg-gray-300 ease-in-out duration-200" (click)="copyRessource(headerService.ressource())">
              {{ headerService.ressource() }}
              <lucide-angular size="12" [name]="Copy"></lucide-angular>
            </button>
          }
        </div>
        <h1
          class="text-2xl w-full font-semibold text-primary dark:text-dark-text"
        >
          @if (headerService.title()) {
            {{ headerService.title() | translate }}
          } @else {
          <ng-content select="[title]"></ng-content>
        }
        </h1>
      </div>
    </div>
    @if (headerService.menu() && headerService.menu().length > 0) {
      <div class="text-secondary dark:text-dark-muted flex items-center justify-center h-full w-[97px] border-l border-l-gray-medium dark:border-l-dark-border relative">
        <a
          href="#"
          class="hover:bg-gray-100 dark:hover:bg-dark-hover ease-in-out transition-all w-full h-full flex items-center justify-center relative"
          [title]="hotkeyService.formatLabel('shift', true)"
          (click)="$event.preventDefault(); actionsOpen = !actionsOpen"
        >
          @if (actionsOpen) {
            <lucide-angular [name]="X"></lucide-angular>
          } @else {
            <lucide-angular [name]="Menu"></lucide-angular>
          }
          <kbd class="absolute bottom-2.5 text-[10px] font-mono text-slate-400 dark:text-dark-muted bg-slate-100 dark:bg-dark-hover border border-slate-200 dark:border-dark-border rounded px-1.5 py-0.5 leading-none">{{ hotkeyService.formatLabel('shift', true) }}</kbd>
        </a>
        @if (actionsOpen) {
          <div #actionMenu class="absolute right-0 bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border border-t-transparent z-20 top-[97px] w-[350px] shadow-sm animate-fadein">
            <ul class="flex flex-col transition-all ease-in-out justify-center">
              @for (item of headerService.menu(); track item.id; let i = $index) {
                <li>
                  <a
                    #menuItem
                    href="#"
                    class="flex items-center w-full px-4 gap-2 text-gray-500 dark:text-dark-muted font-normal text-base hover:text-primary dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-hover py-4 focus:outline-none focus:bg-gray-100 dark:focus:bg-dark-hover focus:text-primary dark:focus:text-gray-200"
                    [ngClass]="{ 'border-b border-b-gray-200 dark:border-b-dark-border': item.breaker, '!text-gray-200 dark:!text-dark-border-light hover:text-gray-200 dark:hover:text-dark-border-light hover:bg-transparent hover:cursor-default': isDisabled(item) }"
                    (click)="$event.preventDefault(); !isDisabled(item) ? handleAction(item) : null"
                    (keydown)="onMenuKeydown($event, i)"
                  >
                    @if (item.icon) {
                      <span [ngClass]="[ isDisabled(item) ? '!text-gray-200 dark:!text-dark-border-light' : item.iconColor ?? 'text-theme-primary' ]">
                        <lucide-angular size="18" [name]="item.icon"></lucide-angular>
                      </span>
                    }
                    <span class="flex-1">{{ item.title | translate }}</span>
                    @if (item.hotkey) {
                      <kbd class="shrink-0 text-[11px] font-mono text-slate-400 dark:text-dark-muted bg-slate-100 dark:bg-dark-hover border border-slate-200 dark:border-dark-border rounded px-1.5 py-0.5 leading-none">
                        {{ hotkeyService.formatLabel(item.hotkey) }}
                      </kbd>
                    }
                  </a>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
  </div>
  <!--- Search --->
  <div
    class="bg-white dark:bg-dark-card border-b border-gray-medium dark:border-dark-border"
    *appIsEmpty
  >
    <ng-content select="[search]"></ng-content>
  </div>

  @if (navItems && navItems.length > 0) {
    <nav class="px-8 border-b bg-white dark:bg-dark-card border-gray-medium dark:border-dark-border">
      <ul class="flex text-sm">
        @for (item of navItems; track index; let index = $index) {
          <li>
            <a
              class="inline-block p-4 text-secondary dark:text-dark-muted border-b-2 border-transparent hover:border-slate-400 dark:hover:border-dark-border-light hover:text-primary dark:hover:text-gray-200 -mb-px"
              [routerLink]="item.route"
              [routerLinkActive]="['!text-theme-primary', '!border-theme-primary']"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ item.title | translate }}
              @if (item.dot?.()) {
                <span class="relative inline-flex ml-1.5 mb-0.5">
                  <span class="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-red-400 opacity-75"></span>
                  <span class="relative inline-flex h-2 w-2 rounded-full bg-red-500"></span>
                </span>
              }
            </a>
          </li>
        }
      </ul>
    </nav>
  }
</header>

<app-alert-service-wrapper area="header"></app-alert-service-wrapper>
